<template>
    <div>
      <loading-component></loading-component>
      <v-main class="page-documentos">
        <v-container fluid fill-height>
          <v-layout justify-center align-center>
            <v-flex xs12 sm10>
              <v-container class="container-documentos">
                <div class="botones-fechas">
                  <button v-on:click="load_documents_day(-1)">
                    <img
                      src="../assets/i/icons/arrow_down.svg"
                      class="icon-row-left"
                    />
                  </button>
                  <v-menu
                    v-model="menuDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{ dateStringCompanion }} {{ dateString | formatDate }}
                      </span>
                    </template>
                    <v-date-picker
                      v-model="dateString"
                      no-title
                      @input="menuDate = false"
                      locale="es-es"
                      :max="today"
                      full-width
                    ></v-date-picker>
                  </v-menu>
                  <button
                    v-if="dateString < today"
                    v-on:click="load_documents_day(1)"
                  >
                    <img
                      src="../assets/i/icons/arrow_down.svg"
                      class="icon-row-right"
                    />
                  </button>
                </div>
                <div v-if="loadingDocuments" class="loading-documents">
                  <v-progress-circular
                    :size="200"
                    :width="10"
                    color="white"
                    indeterminate
                  >
                    Cargando...
                  </v-progress-circular>
                </div>
                <div v-else>
                  <div id="documents-container" v-if="documents.length > 0">
                    <div class="document-container"
                        v-for="(document, index_document) in documents"
                          :key="index_document"
                    >
                    <v-card :href="document.document_file">
                      {{ get_document_name(document)}}
                    </v-card>
                    </div>
                  </div>
                  <div v-else class="no-documents">No hay datos</div>
                </div>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-main>
    </div>
  </template>
  
  <script>
  import LoadingComponent from '../components/LoadingComponent.vue'
  
  export default {
    name: 'documentsView',
    components: {
      LoadingComponent
    },
    data () {
      return {
        show: false,
        title: 'Subasta',
        date: new Date(),
        dateString: null,
        dateStringCompanion: '',
        menuDate: false,
        arrowControl: true,
        loadingDocuments: false,
        timer: null
      }
    },
    watch: {
      dateString () {
        this.load_documents()
      }
    },
    computed: {
      documents () {
        const docs = Array.isArray(this.$store.state.documents) ? this.$store.state.documents.slice() : []

        // Custom priority for document_type
        const priority = { compra: 0, trazabilidad: 1, iccat: 2 }

        // Safe accessor to avoid undefined errors
        const safeName = (d) => (d && d.ship && typeof d.ship.name === 'string') ? d.ship.name : ''

        // Sort by type priority, then by ship name
        return docs.sort((a, b) => {
          // Compare by declared priority
          const pa = priority[a?.document_type] ?? 99
          const pb = priority[b?.document_type] ?? 99
          if (pa !== pb) return pa - pb

          // Fallback: alphabetical by ship.name
          return safeName(a).localeCompare(safeName(b), undefined, {
            sensitivity: 'base',
            numeric: true
          })
        })
      },
      today () {
        return this.format_date(new Date())
      },
      yesterday () {
        return new Date(new Date().setDate(new Date().getDate() - 1))
      }
    },
    methods: {
      PadLeft (value, length) {
        return value.toString().length < length
          ? this.PadLeft('0' + value, length)
          : value
      },
      format_date (localDate) {
        return (
          this.PadLeft(localDate.getFullYear(), 2) +
          '-' +
          this.PadLeft(localDate.getMonth() + 1, 2) +
          '-' +
          this.PadLeft(localDate.getDate(), 2)
        )
      },
      load_documents_day (x) {
        if (this.arrowControl) {
          this.arrowControl = false
          this.date.setDate(this.date.getDate() + x)
          this.dateString = this.format_date(this.date)
          setTimeout(() => {
            this.arrowControl = true
          }, 100)
        }
      },
      get_document_name(document){
        let document_title = document.document_type
        if (document.ship){
          document_title += " "+ document.ship.name
        }
        return document_title
      },
      load_documents () {
        this.loadingDocuments = true
        let dateStringControl = this.dateString
        this.date = new Date(this.dateString)
        if (this.format_date(this.date) === this.today) {
          this.dateStringCompanion = 'HOY'
        } else if (this.format_date(this.date) === this.format_date(this.yesterday)) {
          this.dateStringCompanion = 'AYER'
        } else {
          this.dateStringCompanion = 'DÍA'
        }
        setTimeout(() => {
          if (dateStringControl === this.dateString && this.documentType) {
            this.$api
              .documents(this.dateString, this.documentType)
              .then(() => {
                console.log("todo bien coleguita")
                console.log(this.$store.state.documents)
                this.loadingDocuments = false
              })
              .catch((error) => {
                console.log("todo mal, cabrito")
                if (error.response.status === 403) {
                  this.$store.commit('token', null)
                  this.$router.push('/login')
                }
              })
          }
        }, 500)
      }
    },
    beforeMount () {
      this.dateString = this.format_date(this.date)
      this.documentType = "compra"
    },
    mounted () {
      this.show = true
      // this.$store.commit('pageTitle', 'Subasta')
      // this.$store.commit('pageIcon', 'auctions.svg')
      this.$store.commit('pageTitle', 'Documentos')
      this.$store.commit('pageIcon', 'documents.svg')
      this.$gtag.pageview(this.$route)
    },
  }
  </script>
  